// Generated using typescript-generator version 2.0.400 on 2019-02-11 14:09:31.

import { TradingEntitlements } from "./trading-entitlements";

export interface Position {
    accountNumber: string;
    accountType: string;
    balanceType: string;
    baseCurrency: string;
    custodianCode: string;
    tradeDateQuantity: number;
    lastPrice: number;
    symbol: string;
    cusip: string;
    isin: string;
    marketValueBaseCcy: string;
    security: Security;
}

export interface PdfPacket {
    username: string;
    order: any; 
    entitlements: TradingEntitlements;
    account: Account; 
    _orderProcessing: string; 
    _orderstatus: string; 
    _accountName: string; 
    _acctAddress: string; 
    _orderTitleStyleColor: string; 
    _orderPlacedon: string; 
    origOrder: any; 
    isExtended?: boolean;
    isMultiPositionRedeemOrExchange?: boolean;
}

export interface PositionsNode {
    asOfDate: Date;
    positions: Position[];
}

export interface Security {
    assetType: string;
    assetSubType: string;
    assetSubSubType: string;
    securityType: string;
    assetSubClass: string;
    assetClass: string;
    assetTypeCode: string;
    symbol: string;
    securityDescription: string;
    dividendType: string;
    shortTermCapitalGain: string;
    longTermCapitalGain: string;
    underlyingCusipAvailable: boolean;
}

export interface Account {
    acctNum: string;
    acctShortName: string;
    acctCatgCd: string;
    custodianCd: string;
    businessPurposeCd: string;
    baseCcy: string;
    balanceType: string;
    ibdId: string;
    ip: string;
    ipName: string;
    offNum: string;
    acctAddress: string;
    regType: string;
    introducingFirmCd: string;
    marginEligibleInd: string;
    hasNotes: boolean;
    hasNxcAccess: boolean;
    hasGroup: boolean;
    withholdFlag: boolean;
    hasPesAccess: boolean;
    hasPosition: boolean;
    bankABANum: string;
    bankDDANum: string;
    prodCd: string;
    mnemonic: string;
    cashOnDelivery: boolean;
    acctw8DateChange: number;
    fundBankLinkCd: string;
    marginCallInd: string;
    powerAttorneyInd: string;
    cellPhone: string;
    dayPhone: string;
    homePhone: string;
    emailAddress: string;
    pendingCloseInd: string;
    discretion: string;
    paymntCd: string;
    dividendCd: string;
    transferCd: string;
    proCashInd: string;
    acctProdtProfileCd: string;
    acctAccessCatgCd: string;
    notesText: string;
    acctNavigationTypeCd: string;
    internalAcctId: string;
    ponaInternationalFlag: string;
    acctStatus: string;
    stateCd: string;
    taxIdInd: string;
    acct501: string;
    acct801: string;
    acctClassCd: string;
    shellAcctInd: string;
    coreStoneAcctCd: string;
    accountNonCustodianCode: string;
    optionAuthInd: string;
    optionFunctionCode: string;
    accountObjectionInd: string;
    acctWithHoldCd: string;
    applicantMarginCd: string;
    annuityType: string;
    modelName: string;
    modelUserId: string;
    modelType: string;
    regTypeDescription: string;
    accountTypeDescription: string;
    ownerName: string;
    acctOpenDate: string;
    updatedDate: string;
    accountW9Date: string;
    accountOptionContractsAmount: number;
    acctDeliveryTypeCode: string;
    optionAuthCode: string;
    acctMarginInd: string;
    internalReferenceTaxId: string;
    retirementPlanInd: string;
    ofcNum: string;
    tradeEligInd: boolean;
    acctNick: string;
    group: boolean;
    displayLabel: string;
    groupType: GroupType;
    acctType: string;
    acctClassificationCd: string;
    deactivationDate?: string;
    beingTradedInLevel4PlanAcct: boolean;
    errorCheckingLevel4Plan: boolean;
    tradingEnabled: boolean;
    trading529Enabled: boolean;
    primaryAcct: boolean;
    planLevelCode: string;
    cusipList: Cusip[];
    firmAccount: boolean;
}

export interface Allocation {
    account: Account;
    accounType: AccountType;
    allocationQty: number;
}

export interface DateTimeInfo {
    outDate: string;
    outTime: string;
    outTimeWithMilliseconds: string;
    timeZone: string;
    returnCode: DateTimeInfoReturnCode;
    message: string;
    userMessage: string;
    subReturnCode: string;
    sqlReturnCode: string;
    sqlStatementId: string;
    sqlStateCode: string;
    lastLineNum: string;
    lastParam: string;
}

export interface ExchangeDetails {
    exchangeCode: string;
    exchangeName: string;
}

export interface LotInfo {
    detailDate: string;
    detailTime: string;
    detailQty: string;
    detailPrice: string;
    blockCount: number;
    statusText: string;
}

export interface Quote extends QuoteRemoteResponseRepeated {
    accountNum: string;
    underlyingSecurity: string;
    optionRootSymbol: string;
    description: string;
    securityTypeEnum: SecurityType;
    tradeExchange: TradeExchange;
    cusip: string;
    optionable: boolean;
    strikePrice: number;
    qtDayTime: Date;
    expirationDate: Date;
    returnCode: QuoteReturnCode;
    fundFamilyCode: string;
    fundFamilyName: string;
    fundFamilyRequired: boolean;
    mfTransType: string;
    userState: string;
    fiveTwoNine: boolean;
    refresh: boolean;
}

export interface TaxLot {
    sellMethodName: string;
    sellMethodCode: string;
    dripPosition: boolean;
    dripDefaultSellMethod: string;
    dripDefaultSellMethodText: string;
    methodSelection: boolean;
    lotSelection: boolean;
    realizedLot: boolean;
    processDate: Date;
    batchNumber: string;
    scrollKey: string;
    reassignmentEntitled: boolean;
    reassignmentEligible: boolean;
    all: boolean;
    enterpriseId: string;
    sellingMethods: TaxLotSellingMethods[];
    taxLotDetails: TaxLotDetail[];
    returnCode: number;
    defaultMethodCode: string;
    defaultMethodName: string;
    price: number;
    sourceScreen: string;
    startDate: Date;
    endDate: Date;
    nextScrollKey: string;
    baclkScrollKey: string;
    returnMsg: string;
    errorCode: number;
}

export interface TaxLotDetail {
    lotNo: string;
    coveredInd: string;
    coveredFlag: boolean;
    purchaseDate: Date;
    strPurchaseDate: string;
    availableQty: number;
    disposeQty: number;
    remainingQty: string;
    unitCostAmt: number;
    totalCost: number;
    selected: boolean;
    realizedGLAmt: number;
    lotSelection: boolean;
    giftShareMktVal: number;
    origCostBasis: number;
    unitCostInd: string;
    lotStatusCode: string;
    lotStatus: string;
    enterpriseId: string;
    reqSequenceNum: string;
    realOrUnrealGL: string;
}

export interface TaxLotSellingMethods {
    methodCode: string;
    methodName: string;
}

export interface TradeCommission {
    commType: CommType;
    commissionAmt: number;
    calculatedCommAmt: number;
    groupId: string;
    splitIP1: string;
    splitIP2: string;
    splitIP1Pct: number;
    splitIP2Pct: number;
    principalAmt: number;
    salesCreditAmt: number;
    netAmt: number;
    pershingFee: number;
    secFee: number;
    accIntFee: number;
    otherFee: number;
    miscFee: number;
    totalFee: number;
    returnCode: TradeCommissionReturnCode;
    totBuyComm: number;
    totBuyPrin: number;
    totBuyNet: number;
    totBuyAllFee: number;
    totSelPrin: number;
    totSelNet: number;
    totSelAllFee: number;
    totSelComm: number;
}

export interface TradeDisclaimerText {
    docCatgDesc: string;
    docId: string;
    returnCode: TradeDocTextReturnCode;
    stkDetailText: string;
    stkDetailTextSeq: number;
}

export interface TradingExchangeOrder extends TradingOrderBase {
    orderType: OrderType;
    orgOrderOrderType: OrderType;
    stopPrice?: number;
    limitPrice?: number;
    duration: OrderDuration;
    trailInDollars?: boolean;
    trailDollarQty?: number;
    trailPctQty?: number;
    limitOffset?: number;
    trailingAmt?: number;
    eqtOptTradeReturnCode?: EqtOptTradeReturnCode;
    orderDetailTrailerReturnCode?: EqtOptTradeReturnCode;
    gtdDate?: string;
    addlOrdData?: AddlOrdData[];
    paInd?: string;
    shortSaleName?: string;
    sellerOption?: string;
    exchangeOverride?: string;
    docLocation?: string;
    notes?: string;
    settlementCcy?: string;
    fdid?: string;
    callBackFlag?: string;
    otherPhone?: string;
    phoneAccessID?: string;
    floorInst?: string;
    trailingBasedOn?: string;
    planType?: OrderType;
    secDescTxt?: string;
    securityId?: string;
    strQty?: string;
    optionType?: OptionType;
    strLvsQty?: string;
    nmeTxt2?: string;
    nmeTxt3?: string;
    taxLotSourceCd?: string;
    intlShrtMktAmt?: string;
    tradePrice?: string;
    avgPrcAcct?: string;
    avgPrcAcctTyp?: string;
    netxOpnClsInd?: string;
    taxLotSubTyp?: string;
    pdfDocLoc?: string;
    acctW8Dt?: string;
    acctW9Dt?: string;
    oatsEntryInd?: string;
    chgPct?: string;
    brokerId?: string;
    intlSetlInstOvrCd?: string;
    execBrokerAcctId?: string;
    alertSetupInd?: string;
    unixSendInd?: string;
    numberOfAccounts?: number;
    dollarOrShare?: string;
    dynamicMessageTxt?: string;
    allocations?: Allocation[];
    digitalSignaturesFlg?: string;
    balTypeCd?: string;
    tradeOrderDetailTrailers: TradeOrderDetailTrailer[];
}

export interface TradeOrderDetailTrailer {
    trailer: string;
    netxStopPrc: string;
    netxStplmtPrc: string;
    updateTs: string;
    curMktVal: string;
}

export interface TradingOrderBase {
    enterpriseId?: string;
    solicited?: boolean;
    keyValue?: string;
    trdSrcCde?: string;
    additionalInfo?: string;
    additionalInfoAon?: string;
    additionalInfoNh?: string;
    additionalInfoDnr?: string;
    additionalInfoDni?: string;
    trailer?: string;
    // TODO: trailerDiscExercised & discTrailer dupe. Clean it up in future.
    trailerDiscExercised?: string;
    trailerLot?: string;
    orderApprCode?: string;
    trdOrdCnfrmCd?: string;
    ordQty?: number;
    ordCncldQty?: number;
    orderReferenceNo?: string;
    ordInstrCd?: string;
    tradeEditCode?: string;
    tradeEditMsg?: string;
    varMsgBody?: string;
    ordCallLtrTxt?: string;
    errorTxt?: string;
    ordDtlKey?: string;
    subTranTyp?: string;
    batchNumber?: string;
    processDate?: string;
    sourceSystemKeyID?: string;
    tradeType: TradeType;
    accountType: AccountType;
    editOrder?: boolean;
    approvalRequired?: boolean;
    duplicateOrder?: boolean;
    account: Account;
    marketHour?: string;
    quote: Quote;
    symbolDescription?: string;
    secCommission?: TradeCommission;
    commission?: TradeCommission;
    transactionType?: TransactionType;
    tradingDayInfo?: TradingDayInfo;
    returnCode?: OrderReturnCode;
    orderConfirmed?: boolean;
    ordDtTime?: Date;
    ordDatetimeStr?: string;
    variableMessagesCount?: number;
    variableMessages?: string[];
    entitledForWarningMessageDisplay?: boolean;
    orderDate?: Date;
    taxLot?: TaxLot;
    lotInfo?: LotInfo[];
    editCntForGTReq?: string;
    hasUserSignedExchAgreement?: boolean;
    needsExchAgreement?: boolean;
    isRTQuotesEntitled?: boolean;
    isExecuteAsAgentEnabled?: boolean;
    isExecuteAsAgentOptionEnabled?: boolean;
    nonSolicitedSelect?: string;
    subRequestTypeCode?: number;
    tradingCsrfToken?: string;
    errors?: string[];
    warnings?: string[];
    approvals?: string[];
    infos?: string[];
    ordProdCodeText?: string;
    status?: OrderStatusCode;
    discExercised?: string;
    secIbdOrdRcvDate?: string;
    secIbdOrdRcvTime?: string;
    secIbdOrdRcvTimeZone?: string;
    secIbdOrdRcvFromName?: string;
    secPerOrdRcvDate?: string;
    secPerOrdRcvTime?: string;
    secPerOrdRcvTimeZone?: string;
    secPerOrdRcvFromName?: string;
    secTermsAndConditions?: string;
    oatsDeskReceiptDate1?: string;
    oatsDeskReceiptTime1?: string;
    oatsDeskReceiptZone1?: string;
    oatsDeskTypeCode1?: string;
    ordXctnTxt1?: string;
    oatsDeskReceiptDate2?: string;
    oatsDeskReceiptTime2?: string;
    oatsDeskReceiptZone2?: string;
    oatsDeskTypeCode2?: string;
    ordXctnTxt2?: string;
    ibdMemo?: string;
    addlIbdMemo?: string;
    custOrFirmInd?: string;
    sourceOverride?: string;
    tradingUserRoles?: { [index: string]: any };
    myClientViewUser?: boolean;
    gtdDates?: GTDDates;
    orderAction?: string;
    sellTaxlotId?: string;
    transactionSource?: string;
    chkgActyRefNum?: string;
    acctChgDt?: string;
    rrComment?: string;
    rrNme?: string;
    pct1CommAmt?: string;
    pct2CommAmt?: string;
    pct3CommAmt?: string;
    strPrincipal?: string;
    dvpRvpNmeAddrTxt1?: string;
    newsHeadline1?: string;
    strTrdDt?: string;
    execAllocSeqNum?: string;
    ofxOidDescription?: string;
    formattedOrderPlacedDateTime?: string;
    contextType?: string;
    isUserFromLegacyOTS?: boolean;
}

export interface TradingOrderDetailRemoteRequest {
    customerId: string;
    siteId: string;
    networkId: string;
    acctId: string;
    hostReturnCode: number;
    subRequestTypCde: number;
    fiUserId: string;
    ordOptInd: string;
    ordDtlKey: string;
    sourceOverride: string;
    productType: string;
}

export interface TypeAhead {
    symbol: string;
    cusip: string;
    desc: string;
    secType: string;
    subType: string;
    sedol: string;
    isin: string;
    cntryCde: string;
    currcode: string;
    flagClass: string;
}

export interface MQErrorResponse {
    errorCode: string;
    errorMessage: string;
    exceptionStack: string;
}

export interface QuoteRemoteResponseRepeated {
    blockCount?: number;
    symId: string;
    secNme?: string;
    exchangeCd?: string;
    securityType: string;
    optShrPerContrCnt?: number;
    unusualOptions?: string;
    mainDeliverable?: number;
    sqtBidPrc?: number;
    sqtAskPrc?: number;
    sqtLastPrc?: number;
    sqtChgPrc?: number;
    minPrcVar?: string;
    sqtVol?: number;
    sqtBidsize?: number;
    sqtAsksize?: number;
    eqtOpenPrc?: number;
    eqtClsPrc?: number;
    eqtHiPrc?: number;
    eqtLowPrc?: number;
    eqtAnnlHiPrc?: number;
    eqtAnnlLowPrc?: number;
    eqtDividendPrc?: number;
    eqtPe?: number;
    eqtEps?: number;
    eqtYieldPrc?: number;
    sqtOpenIntrst?: number;
    sqtTrdsize?: number;
    empRstcInd?: string;
    lastTrdTime?: Date;
    lastTrdExch?: string;
    upcInd?: string;
    sqtPctPrc?: string;
    qtMktCap?: string;
    symRetCode?: number;
    haltInd?: string;
    exchDesc?: string;
    qtIntlInd?: string;
    qtCurrencyCd?: string;
    qtExchangeCd?: string;
    qtLastTrdExch?: string;
    blkDelayedQuoteInd?: string;
    textAssetSubStyp?: string;
    gmcExchCde?: string;
    optSym?: string;
    optUnderlyingSymId?: string;
    optDaysLeft?: number;
    optRootSymId?: string;
    optExpnMth?: string;
    optStrikePrc?: number;
    callOrPutCd?: string;
    cusipId?: string;
    secOptblInd?: string;
    secMgnblInd?: string;
    qtProdCd?: string;
    qtByte16Ind?: string;
    qtShrOutstanding?: string;
    qtAvgVol?: number;
    exDivDate?: string;
    divPayDate?: string;
    frgnSecryCde?: string;
    eqtFsiInd?: string;
    eqtFsiDesc?: string;
    askExch?: string;
    bidExch?: string;
    optExpnDt?: Date;
    qtBidExch?: string;
    qtAskExch?: string;
    nyseOpenInd?: string;
    homePageAddr?: string;
    btick?: string;
    qtBidExchDesc?: string;
    qtAskExchDesc?: string;
    qtLastTrdExchDesc?: string;
}

export interface TradingDayInfo {
    isTradingDay: boolean;
    isTradingHrs: boolean;
    isECNPreTradingHrs: boolean;
    isECNPostTradingHrs: boolean;
}

export interface CodeValuesExchange {
    functionName: string;
    codeNme: string;
    codeDesc: string;
}

export interface DateInfo {
    calendarDate: string;
    dateStatusCode: string;
    dateDescription: string;
}

export interface GTDDates {
    nextTradingDate: DateInfo;
    nonBusinessDays: DateInfo[];
}

export interface RegulatoryInfo {
    acctNum: string;
    tranCode: string;
    ibdOrderReceipt: RegulatoryInfoDateTime;
    deskRoute1: RegulatoryInfoDateTime;
    deskRoute2: RegulatoryInfoDateTime;
}

export interface RegulatoryInfoDateTime {
    dateTime: string;
    timezone: SupportedRegulatoryTimeZones;
}

export interface RegulatoryInfoValidationResponse {
    valid: boolean;
    message: string;
    ibdreceiptLaterThanSystem: boolean;
    deskRoute1LaterThanSystem: boolean;
    deskRoute2LaterThanSystem: boolean;
    ibdreceiptLaterThanDeskRoute1: boolean;
    ibdreceiptLaterThanDeskRoute2: boolean;
    deskRoute1LaterThanDeskRoute2: boolean;
}

export interface NetxAddDigSig {
    docId: string;
    docCatgDesc: string;
}

export const enum AccountDbResponseCode {
    SUCCESS,
    NO_DATA_FOUND,
    INVALID_ID,
    BAD_REQUEST,
    SYSTEM_PROBLEM
}

export const enum AccountType {
    CASH = 'CASH',
    MARGIN = 'MARGIN',
    SHORT = 'SHORT',
    COD = 'COD',
    RETIREMENT = 'RETIREMENT',
    PRINCIPAL = 'PRINCIPAL',
    INCOME = 'INCOME'
}

export const enum AcctStatusCde {
    PENDING_CLOSE = 'PENDING_CLOSE',
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED'
}

export const enum AddlOrdData {
    AON = 'AON',
    NOTHELD = 'NOTHELD',
    DONOTREDUCE = 'DONOTREDUCE',
    DONOTINCREASE = 'DONOTINCREASE',
    CASHSAMEDAY = 'CASHSAMEDAY',
    NEXTDAY = 'NEXTDAY',
    EXECUTEASAGENT = 'EXECUTEASAGENT'
}

export const enum ClientGroupAdminReturnCode {
    SUCCESS,
    NO_DATA,
    NOT_AUTHORIZED,
    SYSTEM_UNAVAILABLE,
    FILE_NOT_AVAILABLE,
    SYSTEM_PROBLEM,
    NO_OFFICE,
    INVALID_OFFICE,
    NO_RR,
    INVALID_RR,
    NO_SECURITY_TYPE,
    INVALID_SECURITY_TYPE,
    NO_QUANTITY,
    INVALID_QUANTITY,
    NO_PRICE,
    INVALID_PRICE,
    INVALID_SYMBOL_CUSIP,
    INVALID_DISCOUNT,
    NO_BUY_SELL,
    INVALID_BUY_SELL,
    MORE_DATA,
    FUNCTION_UNAVAILABLE,
    HOST_SYSTEM_UNAVAILABLE,
    MAINFRAME_UNAVAILABLE
}

export const enum CommOrderType {
    MKT_IND,
    LIMIT_IND,
    STOP_IND,
    STOP_LMT_IND
}

export const enum CommTransactionCode {
    TRD_FIG_TRD_BUY,
    TRD_FIG_TRD_SELL
}

export const enum CommType {
    RTE = 'RTE',
    MLT = 'MLT',
    COM = 'COM',
    MUD = 'MUD',
    MUD_AUTO = 'MUD_AUTO',
    PFM = 'PFM'
}

export const enum ContributionType {
    CURRENT_YEAR = 'CURRENT_YEAR',
    PRIOR_YEAR = 'PRIOR_YEAR',
    ROLLOVER = 'ROLLOVER'
}

export const enum DateTimeInfoReturnCode {
    SUCCESS,
    BAD_REQUEST,
    SYSTEM_PROBLEM
}

export const enum DeskRouteTimeZone {
    CT = 'CT',
    PT = 'PT',
    MT = 'MT',
    ET = 'ET'
}
export const enum DeskRouteCode {
    A = 'A',
    AR = 'AR',
    B = 'B',
    C = 'C',
    D = 'D',
    IS = 'IS',
    IN = 'IN',
    O = 'O',
    PF = 'PF',
    PT = 'PT',
    PR = 'PR',
    S = 'S',
    T = 'T',
    TR = 'TR',
    SW = 'SW',
    EC = 'EC',
    CR = 'CR'
}
export const AcctClassificationCdArray= [
    'AP',
    'CO',
    'FA',
    'IA',
    'IN',
    'OB'
];

export const enum EntitlementId {
    STOCK_TRADING,
    OPTIONS_TRADING,
    MUTUAL_FUND_TRADING,
    XTND_HOURS,
    STOP_LIMIT_TRADING,
    DELAYED_EQUITY_QUOTES,
    REAL_TIME_EQUITY_QUOTES,
    DELAYED_OPTION_QUOTES,
    REAL_TIME_OPTION_QUOTES,
    MUTUAL_FUND_QUOTES,
    RT_QUOTES_TRADING,
    STREAMING_QUOTES,
    PERSHING_WATCHLIST,
    STOP_LIMIT_OPTION_ORDER,
    STOP_OPTION_ORDER,
    EDIT_DEFAULT_REINVESTMENT,
    ACCOUNT_SUMMARY,
    ACCOUNT_SUMMARY_1,
    MOD_MARKETS,
    MOD_QUOTES_NEWS,
    MOD_TOOLS,
    MOD_ETF_SCREENER,
    MOD_BRONZE,
    MOD_SILVER,
    MOD_GOLD,
    MOD_PLATINUM,
    MOD_STOCK_SCREENER,
    MOD_MUTUAL_FUND_SCREENER,
    ORDER_STATUS,
    ALERTS,
    ALERTS_TRADE,
    ALERTS_ACTIVITY,
    ALERTS_MARGIN,
    ALERTS_PUBLICATION,
    ALERTS_RESEARCH,
    ALERTS_POSITIONS_SUMMARY,
    ASSET_ALLOCATION_ALERTS,
    E_DOCUMENTS,
    ELECTRONIC_NOTIFICATION,
    HISTORY,
    HISTORY_NAVIGATION,
    COMPOSITION,
    HOLDINGS,
    GAIN_LOSS,
    BALANCES,
    INTRADAY_BALANCES_NAVIGATION,
    DAY_TRADING_BUYING_POWER,
    HOLDINGS_WITH_RT_QUOTES,
    ASSET_ALLOCATION,
    EQUITY_SECTOR,
    EQUITY_TYPE,
    CUSTOM_ASSET_CLASSIFICTION,
    NXC_BASIC_CONTENT,
    BETA_FEEDBACK,
    MASK_ACCOUNT_NUMBERS,
    SOLICITED_ORDER_INDICATOR,
    ORDER_PROSPECTUS,
    MF_TOOL,
    TAX_GUIDE,
    REALIZED_GAIN_LOSS,
    LOCKWOOD_QPRS_MNG_PERFORM,
    LOCKWOOD_DPRS_MNG_PERFORM,
    LOCKWOOD_QPRS_PMAS,
    FOREIGN_CURRENCY_DISPLAY,
    ANY,
    MAG_ACCT_PROFILE,
    INV_MANAGER_AND_STYLE,
    ACCOUNT_PROFILE,
    CASH_FLOW,
    FINRA_INVESTOR_RESOURCES,
    PATH_TO_INVESTING,
    SEC_INVESTOR_EDUCATION,
    UGL_WITH_RT_QUOTES,
    BILLSUITE,
    ACCOUNT_GROUP,
    HOUSEHOLD_PROFILE,
    RATEBOARD,
    VALUATION_OVER_TIME,
    COMMISION_CALCULATOR,
    CONTACT_BROKERAGE,
    OUTSIDE_LINKS,
    TURBO_TAX,
    FINANCIAL_ADVISOR,
    CANCEL_REPLACE,
    HR_BLOCK,
    MOBILE,
    COMMISSION_SCHEDULE,
    EDELIVERY_ONLY,
    CITI_SYNDICATES_AND_STRCTNOTES,
    FINRA_CALCULATOR,
    FREQUENTLY_ASKED_QUESTIONS,
    CITI_RESEARCH,
    SP_RESEARCH,
    HISTORIC_DOCS,
    HISTORIC_DATA,
    COLLEGE_PLAN_INFORMATION,
    TRADING_529_FUND,
    FIXED_INCOME_SEARCH,
    DB_EQUITY_RESEARCH,
    SOLAR_PORTFOLIOS,
    HEWITT_PAYROLL,
    ABOUT_US,
    DOWNLOAD_FORMS,
    ACCOUNT_OPENING,
    STATEMENTS,
    TRADE_CONFIRMATIONS,
    TAX_STATEMENTS,
    NOTIFICATIONS,
    HISTORICAL_DOCUMENT,
    BCL_RESEARCH,
    CSFB_ALTERNATIVEINVESTMENTS,
    CSFB_BANKPRODUCTS,
    CREDIT_SUISSE_RESEARCH,
    ADVISOR_GROUP_PERFORMANCE,
    INVESTMENT_STRATEGY,
    CONSOLIDATED_CLIENT_REPORTING,
    RUSSELLTICK_REAL_TIME,
    RUSSELLTICK_REAL_TIME_STREAM,
    RUSSELLTICK_DELAYED,
    NYSE_GIF_REAL_TIME,
    NYSE_GIF_REAL_TIME_STREAMING,
    NYSE_GIF_DELAYED,
    NASDAQ_GIDS_REAL_TIME,
    NASDAQ_GIDS_REAL_TIME_STREAM,
    NASDAQ_GIDS_DELAYED,
    NASDAQ_MFDS_REAL_TIME,
    NASDAQ_MFDS_REAL_TIME_STREAM,
    NASDAQ_MFDS_DELAYED,
    MARKET_DATA_EXPRESS_RT_SNAP,
    MARKET_DATA_EXPRESS_RT_STREAM,
    MARKET_DATA_EXPRESS_MDI_DELAY,
    DJ_INDICIES_RT,
    DJ_INDICIES_RT_STREAMING,
    DOW_JONES_INDICIES_DELAYED,
    EQUITY_AWARDS,
    MANAGE_DISPOSTION_METHOD,
    HIDE_FUNDS_AVAIL_FOR_WITHDRAWAL,
    MUTUAL_FUND_INCOME_PROJECTIONS,
    OVERVIEW_DAY_CHANGE,
    OVERVIEW_UGL,
    NXI_MOBILE_CHECK_DEPOSIT_REMITPRO,
    ACCOPEN_IBD_TEST,
    TRAILING_STOPS,
    LIABILITIES_BALANCE,
    FIXED_INCOME_INVENTORY,
    LOCKWOOD_QPRS_PMAS_PSEUDO,
    ACCOUNT_PROFILE_UPDATE,
    FOREIGN_ADDRESS_UPDATE,
    FUNDS_TRANSFER,
    ASSET_TRANSFER_MASTER,
    SHARED_DOCUMENT_ALERTS,
    ADVISOR_PASSWORD_RESET_UNLOCK,
    ADVISOR_SECURITY_SETTINGS,
    MANAGE_USER_ADMIN,
    PORTFOLIOPLUS,
    MUTUAL_FUND_SELL_BUYNG,
    GLOBAL_SHARES_ESOP,
    VIRTUAL_DIGTIAL_ADVICE,
    GENERATE_OTP,
    NXI_FINANCIAL_PLANNING_ACCESS,
    WARNING_MESSAGE_DISPLAY,
    ADVISOR_PRIVY,
    TOUCH_ID,
    ADD_NEW_STANDING_INSTRUCTION,
    REQUEST_A_CHECK,
    ENABLE_NTF_ETF_SCREENER,
    PIPER_SSO_TO_MARKIT,
    PORTFOLIO_MOVERS,
    POST_LOGIN_MSGS,
    DISPLAY_SETTINGS,
    MESSAGE_CENTER,
    DEFAULT_ACCOUNT,
    VIEW_TAX_RECLAIM_RECEIVABLES,
    RIA_USER,
    BD_USER,
    NON_DOLLAR_ENT,
    FLOOR_INSTRUCTION_ENT,
    EXCH_OVERRIDE_ENT,
    EAG_ENT,
    AIG_ENT
}

export const enum EqtOptTradeReturnCode {
    SUCCESS,
    ORDER_WARNING,
    ORDER_APPROVAL,
    INVALID_REQUEST,
    ORDER_SEVERE,
    BAD_REQUEST,
    DAY_ORDER_EXPIRED,
    BEING_PROCESSED,
    SYSTEM_UNAVAILABLE,
    FILE_NOT_AVAILABLE,
    SYSTEM_PROBLEM,
    EDIT_ERROR,
    INSUF_CASH_BUY_POWER,
    INSUF_CASH_X_TO_MARGIN,
    DUPE_ORDER,
    MULTIPLE_DUPE_ORDERS,
    IRA_EXCEEDS_AVAIL_CASH,
    INSUF_CASH_FOR_C_P,
    INSUF_UNDERLYING_SECS,
    UNCOVERED_CALL,
    SEC_NOT_DELIVERABLE,
    ACCOUNT_CLOSED,
    ACCOUNT_PENDING_CLOSE,
    MARGIN_ERROR,
    INSUF_POSITION_TO_SELL,
    INSUF_POSTION_TO_SELL_2,
    RULES_ENGINE_ERROR,
    UPLINK_ERROR,
    MORE_DATA,
    FUNCTION_UNAVAILABLE,
    HOST_SYSTEM_UNAVAILABLE,
    MAINFRAME_MAINTENANCE,
    MAINFRAME_UNAVAILABLE,
    REFRESH_CHANGE_ORDER
}

export const enum GroupType {
    CUSTOMER,
    LOCKWOOD
}

export const enum IdSourceNetwork {
    INTERNET,
    PRODIGY,
    COMPUSERVE,
    MSI,
    POL,
    BLOOMBERG,
    AOL,
    QTRADE,
    QUICKEN,
    AOLCD,
    MSNMKSPD,
    AOLMKSPD,
    MSN99
}

export const enum InstrumentReturnCode {
    SUCCESS,
    NO_DATA,
    INVALID_REQUEST,
    BAD_REQUEST,
    SYSTEM_PROBLEM,
    MORE_DATA
}

export const enum MFDvreType {
    CASH = 'CASH',
    REINVEST = 'REINVEST',
    DIVIDEND = 'DIVIDEND',
    CAPITAL = 'CAPITAL'
}

export const enum MFLookupReturnCode {
    SUCCESS,
    NO_DATA,
    INVALID_REQUEST,
    INVALID_USER,
    BAD_REQUEST,
    SYSTEM_PROBLEM,
    BLUE_SKY_ERR,
    MORE_DATA,
    MAINFRAME_UNAVAILABLE,
    NOT_ALLOWED_TO_BUY
}

export const enum MFProceedsType {
    ACH,
    PBC,
    MMS
}

export const enum MQErrorCode {
    MQ_NOT_AVAILABLE,
    MQ_TIMEOUT,
    MQ_SEND_RECEIVE_FAILURE,
    MQ_CONNECTION_FAILURE,
    MQ_UNKNOWN_SVC_EXCEPTION,
    MQ_INVALID_REQUEST,
    MQ_INVALID_USER,
    MQ_SYSTEM_UNAVAILABLE,
    MQ_FILE_NOT_AVAILABLE,
    MF_ABEND
}

export const enum MutualFundRequestType {
    REVIEW_ORDER,
    SEND_ORDER,
    CANCEL_ORDER
}

export const enum MutualFundTradeReturnCode {
    SUCCESS,
    ORDER_WARNING,
    NO_DATA,
    ORDER_APPROVAL,
    INVALID_REQUEST,
    ORDER_SEVERE,
    INVALID_USER,
    DAY_ORDER_EXPIRED,
    BAD_REQUEST,
    BEING_PROCESSED,
    SYSTEM_UNAVAILABLE,
    FILE_NOT_AVAILABLE,
    SYSTEM_PROBLEM,
    EDIT_ERROR,
    INSUF_CASH_BUY_POWER,
    INSUF_CASH_X_TO_MARGIN,
    DUPE_ORDER,
    MULTIPLE_DUPE_ORDERS,
    CANCEL_MISMATCH,
    ORDER_NOT_FOUND,
    ORDER_CANNOT_CHANGE,
    ORDER_CANNOT_CANCEL,
    MF_INSUF_POSTION_TO_SELL,
    MISSED_CUTOFF,
    NTF_ERROR,
    EXCEEDS_AVAIL_CASH,
    MF_ACCOUNT_CLOSED,
    MF_ACCOUNT_PENDING_CLOSE,
    MF_MARGIN_ERROR,
    MISSED_CUTOFF_ACK,
    IBD_INELGI_OFFSHORE,
    ROPES_SYSTEM_DOWN,
    BLUE_SKY_ERR,
    RULES_ENGINE_ERROR,
    UPLINK_ERROR,
    MORE_DATA,
    FUNCTION_UNAVAILABLE,
    HOST_SYSTEM_UNAVAILABLE,
    MAINFRAME_MAINTENANCE,
    MAINFRAME_UNAVAILABLE,
    NOT_ALLOWED_TO_BUY,
    UNABLE_TO_PROSS_CALL_OFFICE_1,
    EDITING_ORDER_CALL_OFFICE,
    FUND_TRADE_IN_CASH_ACCT,
    NO_SELL_ORDERS,
    EXISTING_ORDER,
    MULTIPLE_ORDER_PLACE,
    ORDER_SENT_1,
    RESTRICT_TRADE,
    MUST_BE_IN_RECEIPT,
    MAX_SHARE_ERROR_1,
    UNABLE_TO_PROSS_CALL_OFFICE_2,
    UNABLE_TO_PROSS_CALL_OFFICE_3,
    NEED_CASH_1,
    NO_NEW_INVESTORS,
    NO_ADD_PURCHASES,
    QTY_ERROR,
    MAX_SHARE_ERROR_2,
    MAX_SHARE_ERROR_3,
    MAX_SHARE_ERROR_4,
    ORDER_SENT_2,
    ORDER_NOT_FOUND_2,
    MF_CUT_OFF_ERROR_1,
    TRANSACTION_FEE_CHARGE,
    INCUR_LOAD_FEE,
    TRANS_FEE_1,
    TRANS_FEE_2,
    APPLY_CHARGE_1,
    TRANS_FEE_3,
    APPLY_CHARGE_2,
    NEED_CASH_2,
    MF_CUT_OFF_ERROR_2,
    MF_CUT_OFF_ERROR_3,
    MF_CUT_OFF_ERROR_4
}

export const enum MutualFundType {
    LOW_LOAD_FUND,
    LOAD_FUND,
    NO_LOAD_FUND
}

export const enum OptionType {
    PUT = 'PUT',
    CALL = 'CALL',
    BOTH = 'BOTH'
}

// This enum is NOT duplicated on the server and values from it are never sent to the server.
// However, still using an enum here for this values to avoid code duplication and ensure all
// references are consistent with other select fields.
export const enum OptionStrategy {
    SINGLE = 'SINGLE',
    BUY_WRITE = 'BUY_WRITE',
    CALENDAR_SPREAD = 'CALENDAR_SPREAD',
    COLLAR = 'COLLAR',
    DIAGONAL_SPREAD = 'DIAGONAL_SPREAD',
    MARRIED_PUT = 'MARRIED_PUT',
    ROLL = 'ROLL',
    STRADDLE = 'STRADDLE',
    STRANGLE = 'STRANGLE',
    VERTICAL_SPREAD = 'VERTICAL_SPREAD',
    RATIO = 'RATIO'
}

export const enum OrderDuration {
    DAY = 'DAY',
    GTC = 'GTC',
    PREMKT = 'PREMKT',
    AFTMKT = 'AFTMKT',
    OPG = 'OPG',
    IOC = 'IOC',
    FOK = 'FOK',
    GTX = 'GTX',
    GTD = 'GTD',
    GTM = 'GTM',
    GTW = 'GTW',
    CRS = 'CRS',
    NA = 'NA'
}

export const enum OrderReturnCode {
    SUCCESS = 'SUCCESS',
    ORDER_WARNING = 'ORDER_WARNING',
    ORDER_APPROVAL = 'ORDER_APPROVAL',
    INVALID_REQUEST = 'INVALID_REQUEST',
    ORDER_SEVERE = 'ORDER_SEVERE',
    BAD_REQUEST = 'BAD_REQUEST',
    DAY_ORDER_EXPIRED = 'DAY_ORDER_EXPIRED',
    BEING_PROCESSED = 'BEING_PROCESSED',
    SYSTEM_UNAVAILABLE = 'SYSTEM_UNAVAILABLE',
    FILE_NOT_AVAILABLE = 'FILE_NOT_AVAILABLE',
    SYSTEM_PROBLEM = 'SYSTEM_PROBLEM',
    EDIT_ERROR = 'EDIT_ERROR',
    INSUF_CASH_BUY_POWER = 'INSUF_CASH_BUY_POWER',
    INSUF_CASH_X_TO_MARGIN = 'INSUF_CASH_X_TO_MARGIN',
    DUPE_ORDER = 'DUPE_ORDER',
    MULTIPLE_DUPE_ORDERS = 'MULTIPLE_DUPE_ORDERS',
    IRA_EXCEEDS_AVAIL_CASH = 'IRA_EXCEEDS_AVAIL_CASH',
    INSUF_CASH_FOR_C_P = 'INSUF_CASH_FOR_C_P',
    INSUF_UNDERLYING_SECS = 'INSUF_UNDERLYING_SECS',
    UNCOVERED_CALL = 'UNCOVERED_CALL',
    SEC_NOT_DELIVERABLE = 'SEC_NOT_DELIVERABLE',
    ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
    ACCOUNT_PENDING_CLOSE = 'ACCOUNT_PENDING_CLOSE',
    MARGIN_ERROR = 'MARGIN_ERROR',
    INSUF_POSITION_TO_SELL = 'INSUF_POSITION_TO_SELL',
    INSUF_POSTION_TO_SELL_2 = 'INSUF_POSTION_TO_SELL_2',
    RULES_ENGINE_ERROR = 'RULES_ENGINE_ERROR',
    UPLINK_ERROR = 'UPLINK_ERROR',
    UPLINK_TIMEOUT_WARNING = 'UPLINK_TIMEOUT_WARNING',
    FUNCTION_UNAVAILABLE = 'FUNCTION_UNAVAILABLE',
    HOST_SYSTEM_UNAVAILABLE = 'HOST_SYSTEM_UNAVAILABLE',
    MAINFRAME_UNAVAILABLE = 'MAINFRAME_UNAVAILABLE',
    MAINFRAME_MAINTENANCE = 'MAINFRAME_MAINTENANCE',
    MISSED_CUTOFF = 'MISSED_CUTOFF',
    MISSED_CUTOFF_ACK = 'MISSED_CUTOFF_ACK',
    NTF_ERROR = 'NTF_ERROR',
    EXCEEDS_AVAIL_CASH = 'EXCEEDS_AVAIL_CASH',
    ROPES_SYSTEM_DOWN = 'ROPES_SYSTEM_DOWN',
    ADVISOR_SUBMIT = 'ADVISOR_SUBMIT',
    REFRESH_CHANGE_ORDER = 'REFRESH_CHANGE_ORDER',
    EDITING_ORDER_CALL_OFFICE = 'EDITING_ORDER_CALL_OFFICE',
    FUND_TRADE_IN_CASH_ACCT = 'FUND_TRADE_IN_CASH_ACCT',
    NO_SELL_ORDERS = 'NO_SELL_ORDERS',
    EXISTING_ORDER = 'EXISTING_ORDER',
    MULTIPLE_ORDER_PLACE = 'MULTIPLE_ORDER_PLACE',
    RESTRICT_TRADE = 'RESTRICT_TRADE',
    MUST_BE_IN_RECEIPT = 'MUST_BE_IN_RECEIPT',
    NO_NEW_INVESTORS = 'NO_NEW_INVESTORS',
    NO_ADD_PURCHASES = 'NO_ADD_PURCHASES',
    QTY_ERROR = 'QTY_ERROR',
    TRANSACTION_FEE_CHARGE = 'TRANSACTION_FEE_CHARGE',
    INCUR_LOAD_FEE = 'INCUR_LOAD_FEE',
    ORDER_NOT_FOUND_2 = 'ORDER_NOT_FOUND_2',
    TRANS_FEE_1 = 'TRANS_FEE_1',
    TRANS_FEE_2 = 'TRANS_FEE_2',
    TRANS_FEE_3 = 'TRANS_FEE_3',
    ORDER_SENT_1 = 'ORDER_SENT_1',
    ORDER_SENT_2 = 'ORDER_SENT_2',
    APPLY_CHARGE_1 = 'APPLY_CHARGE_1',
    APPLY_CHARGE_2 = 'APPLY_CHARGE_2',
    NEED_CASH_1 = 'NEED_CASH_1',
    NEED_CASH_2 = 'NEED_CASH_2',
    MAX_SHARE_ERROR_1 = 'MAX_SHARE_ERROR_1',
    MAX_SHARE_ERROR_2 = 'MAX_SHARE_ERROR_2',
    MAX_SHARE_ERROR_3 = 'MAX_SHARE_ERROR_3',
    MAX_SHARE_ERROR_4 = 'MAX_SHARE_ERROR_4',
    MF_CUT_OFF_ERROR_1 = 'MF_CUT_OFF_ERROR_1',
    MF_CUT_OFF_ERROR_2 = 'MF_CUT_OFF_ERROR_2',
    MF_CUT_OFF_ERROR_3 = 'MF_CUT_OFF_ERROR_3',
    MF_CUT_OFF_ERROR_4 = 'MF_CUT_OFF_ERROR_4',
    UNABLE_TO_PROSS_CALL_OFFICE_1 = 'UNABLE_TO_PROSS_CALL_OFFICE_1',
    UNABLE_TO_PROSS_CALL_OFFICE_2 = 'UNABLE_TO_PROSS_CALL_OFFICE_2',
    UNABLE_TO_PROSS_CALL_OFFICE_3 = 'UNABLE_TO_PROSS_CALL_OFFICE_3'
}

export const enum OrderStatusCode {
    OPEN = 'OPEN',
    OPEN_TRAILING = 'OPEN_TRAILING',
    OPEN_ELECTED = 'OPEN_ELECTED',
    PART_EXECUTED = 'PART_EXECUTED',
    CLOSED = 'CLOSED',
    ALL = 'ALL',
    OPEN_PNDNG = 'OPEN_PNDNG',
    OPENED = 'OPENED',
    PENDING = 'PENDING',
    PENDING_CANCEL = 'PENDING_CANCEL',
    EXECUTED = 'EXECUTED',
    REJECTED = 'REJECTED',
    CANCELED = 'CANCELED',
    NONEXECUT = 'NONEXECUT',
    SENT = 'SENT',
    PENDING_PART_CANCEL = 'PENDING_PART_CANCEL',
    PART_CANCELED = 'PART_CANCELED',
    PART_MIXED = 'PART_MIXED',
    DROPPED = 'DROPPED',
    CORRECTED = 'CORRECTED',
    MIXED = 'MIXED',
    BUSTED = 'BUSTED',
    ASPS_REJECT = 'ASPS_REJECT',
    SPONSOR_REJECT = 'SPONSOR_REJECT',
    ERE_REJECT = 'ERE_REJECT',
    APPROVER_REJECT = 'APPROVER_REJECT',
    CARRIER_REJECT = 'CARRIER_REJECT',
    DTDC_REJECT = 'DTDC_REJECT',
    MANUAL_REJECT = 'MANUAL_REJECT',
    ACCEPTED = 'ACCEPTED',
    INCOMPLETE = 'INCOMPLETE',
    BLOCK = 'BLOCK',
    WORKED_ON_CANCEL = 'WORKED_ON_CANCEL',
    IN_REPAIR = 'IN_REPAIR',
    PENDING_PROCESSING = 'PENDING_PROCESSING',
    PROCESSED = 'PROCESSED',
    HOLD = 'HOLD',
    INVALID_CANCEL = 'INVALID_CANCEL',
    TRADE_REJECT = 'TRADE_REJECT',
    RULES_ENGINE_FAIL = 'RULES_ENGINE_FAIL',
    RULES_ENGINE_REJECT = 'RULES_ENGINE_REJECT',
    TPS_EDIT_ERROR = 'TPS_EDIT_ERROR',
    TPS_EDIT_FAIL = 'TPS_EDIT_FAIL',
    GLOBAL_BILL_REJECT = 'GLOBAL_BILL_REJECT',
    ABEND = 'ABEND',
    ACCEPT_CANCEL = 'ACCEPT_CANCEL',
    AWAITING_CANCEL = 'AWAITING_CANCEL',
    OPTION_EXPIRED = 'OPTION_EXPIRED',
    WORKED_ON = 'WORKED_ON',
    REJECT_CANCEL = 'REJECT_CANCEL',
    SENT_CANCEL = 'SENT_CANCEL'
}

export const enum OrderStatusProductType {
    EQUITY,
    OPTION,
    DOMESTIC_MF,
    OFFSHORE_MF,
    FIXED_INCOME,
    ANNUITY,
    INTERNATIONAL_TRADE,
    CURRENCY,
    NON_DOLLAR_EQUITIES,
    AIN
}

export const enum OrderType {
    MARKET = 'MARKET',
    LIMIT = 'LIMIT',
    STOP = 'STOP',
    AON = 'AON',
    FOK = 'FOK',
    STOP_LIMIT = 'STOP_LIMIT',
    STOP_LIMIT_AON = 'STOP_LIMIT_AON',
    // TRAILING_STOP = 'TRAILING_STOP',
    // TRAILING_STOP_LIMIT = 'TRAILING_STOP_LIMIT',
    // TRAILING_STOP_AON = 'TRAILING_STOP_AON',

    TRAILING_STOP_DOLLAR = 'TRAILING_STOP_DOLLAR',
    TRAILING_STOP_PCT = 'TRAILING_STOP_PCT',

    TRAILING_STOP_LIMIT_DOLLAR = 'TRAILING_STOP_LIMIT_DOLLAR',
    TRAILING_STOP_LIMIT_PCT = 'TRAILING_STOP_LIMIT_PCT',

    TRAILING_STOP_LIMIT_AON = 'TRAILING_STOP_LIMIT_AON',
    TRAILING_STOP_LIMIT_PCT_AON = 'TRAILING_STOP_LIMIT_PCT_AON',

    EXECUTE_AT_CLOSE = 'EXECUTE_AT_CLOSE',
    LIMIT_ON_CLOSE = 'LIMIT_ON_CLOSE',
    OR_BETTER = 'OR_BETTER',
    WOW = 'WOW',
    NET_CREDIT = 'NET_CREDIT',
    NET_DEBIT = 'NET_DEBIT',
    EVEN = 'EVEN'
}

export const enum QuoteReturnCode {
    SUCCESS = 'SUCCESS',
    SYM_NOT_FOUND = 'SYM_NOT_FOUND',
    QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE',
    SYS_ERROR = 'SYS_ERROR',
    ZERO_BANK = 'ZERO_BANK',
    BAD_REQUEST = 'BAD_REQUEST',
    INVALID_EXCHANGE = 'INVALID_EXCHANGE',
    REQ_TIMEOUT = 'REQ_TIMEOUT'
}

export const enum QuoteType {
    DELAYED,
    REALTIME,
    REALTIME_NOQUOTE_CHARGE_ECN,
    REALTIME_NOQUOTE_CHARGE
}

export const enum ReturnCodeType {
    SUCCESS,
    WARNING,
    ERROR
}

export const enum SecurityType {
    EQUITY = 'EQUITY',
    OPTION = 'OPTION',
    INDEX = 'INDEX',
    MUTUAL_FUND = 'MUTUAL_FUND',
    PLAN_529FUND = 'PLAN_529FUND',
    FIXED_INCOME = 'FIXED_INCOME',
    CASH_MONEY = 'CASH_MONEY',
    OTHER = 'OTHER',
    SYMBOL_CUSIP = 'SYMBOL_CUSIP',
    SYMBOL_TYPE_ALL = 'SYMBOL_TYPE_ALL',
    ALL = 'ALL'
}

export const enum SubReturnCode {
    SUCCESS,
    CASH_ONLY,
    TRADE_RESTRICTED,
    DUPE_ORDER,
    DUPE_ORDER_5,
    NOT_FOR_SELL,
    RECEIPT_REQUIRE,
    SELL_QTY_GRATER,
    ORDER_UNDER_PROCESS,
    ORDER_UNDER_PROCESS_10,
    ORDER_NOT_FOUND,
    ADDL_CASH_REQUIRE,
    ADDL_CASH_REQUIRE_15,
    CLOSED_FOR_NEW_INVESTOR,
    NO_ADDL_PURCHASE,
    ERR_TEXT,
    INCUR_LOAD_FEE_DIFF,
    TRANSACTION_FEE_APPLY,
    DAILY_CUT_OFF_PASSED,
    TRANSACTION_FEE_APPLY_27,
    NOT_HELD_FOR_6_MONTHS,
    TRANSACTION_FEE_APPLY_29,
    NOT_HELD_FOR_6_MONTHS_30,
    SELL_QTY_GRATER_31,
    SELL_QTY_GRATER_32,
    SELL_QTY_GRATER_33
}

export const enum SupportedRegulatoryTimeZones {
    CT = 'CT',
    // GMT-4
    PT = 'PT',
    // GMT-8
    MT = 'MT',
    // GMT-9
    ET = 'ET'
}

export const enum TaxLotAssetCategory {
    EQUITY,
    OPTION,
    OTC,
    FIXED_INCOME
}

export const enum TaxLotRequestType {
    SELLMETHOD,
    GETTAXLOT,
    EDITTAXLOT,
    VIEWTAXLOT,
    SUBMITTAXLOT,
    ACTIVITY,
    SUBMITTAXLOTREASSIGN
}

export const enum TaxLotSourceSystems {
    AOMS,
    AMPSJRNL,
    AMPSACAT,
    MFNL,
    DMM,
    ACCTHLDG,
    CHGOREQU
}

export const enum TaxLotTransactionTypes {
    SELL_FROM_PORTFOLIO,
    BUY_TO_COVER,
    TRANSFER,
    REDEEM,
    EXCHANGE
}

export const enum TradeCommissionReturnCode {
    SUCCESS,
    NOT_AUTHORIZED,
    SYSTEM_UNAVAILABLE,
    FILE_NOT_AVAILABLE,
    SYSTEM_PROBLEM,
    NO_OFFICE,
    INVALID_OFFICE,
    NO_RR,
    INVALID_RR,
    NO_SECURITY_TYPE,
    INVALID_SECURITY_TYPE,
    NO_QUANTITY,
    INVALID_QUANTITY,
    NO_PRICE,
    INVALID_PRICE,
    INVALID_SYMBOL_CUSIP,
    MULTIPLE_ERRORS,
    INVALID_DISCOUNT,
    NO_BUY_SELL,
    INVALID_BUY_SELL,
    FUNCTION_UNAVAILABLE,
    HOST_SYSTEM_UNAVAILABLE,
    MAINFRAME_UNAVAILABLE,
    FRACTION_SHARES_NOT_ALLOWED,
    INCOMPLETE_TRADEFIG
}

export const enum TradeDocTextReturnCode {
    SUCCESS,
    NO_DATA,
    INVALID_REQUEST,
    INVALID_USER,
    BAD_REQUEST,
    SYSTEM_UNAVAILABLE,
    FILE_NOT_AVAILABLE,
    SYSTEM_PROBLEM,
    GET_DOC_INVALID_ACCOUNT,
    INVALID_DOC_TEXT_SEQ,
    DOC_NOT_FOUND,
    GET_DOC_INVALID_SITE_ID,
    MORE_DATA,
    FUNCTION_UNAVAILABLE,
    HOST_SYSTEM_UNAVAILABLE,
    MAINFRAME_UNAVAILABLE,
    MAINFRAME_MAINTENANCE
}

export const enum TradeExchange {
    NYSE = 'NYSE',
    AMEX = 'AMEX',
    PHIL = 'PHIL',
    OTC = 'OTC',
    BSE = 'BSE',
    CSE = 'CSE',
    CBOE = 'CBOE',
    NSCC = 'NSCC',
    PAC = 'PAC',
    NASD_STR = 'NASD_STR',
    NYSE_STR = 'NYSE_STR',
    NASD_BB = 'NASD_BB',
    AMEX_STR = 'AMEX_STR',
    BSE_STR = 'BSE_STR',
    CBOE_STR = 'CBOE_STR',
    CINN = 'CINN',
    PHLX = 'PHLX',
    BATS = 'BATS',
    MIDWEST = 'MIDWEST',
    PCSE = 'PCSE',
    NASD = 'NASD',
    NASD_NM = 'NASD_NM',
    NASD_SC = 'NASD_SC',
    NASDAQ = 'NASDAQ',
    NASDAQ_NM = 'NASDAQ_NM',
    NASDAQ_SC = 'NASDAQ_SC',
    OTCBB = 'OTCBB',
    PHILA = 'PHILA',
    MWSE = 'MWSE',
    NNQS = 'NNQS',
    Other = 'Other'
}

export const enum TradeType {
    EQUITY = 'EQUITY',
    MUTUAL_FUND = 'MUTUAL_FUND',
    PLAN_529FUND = 'PLAN_529FUND',
    OPTION = 'OPTION',
    EXTENDED_HOURS = 'EXTENDED_HOURS',
    ANNUITY = 'ANNUITY'
}

export const enum TransactionType {
    BUY = 'BUY',
    BUY_TO_COVER = 'BUY_TO_COVER',
    SELL_FROM_PORTFOLIO = 'SELL_FROM_PORTFOLIO',
    SELL_NOT_IN_ACCOUNT = 'SELL_NOT_IN_ACCOUNT',
    SELL = 'SELL',
    SELL_SHORT = 'SELL_SHORT',
    SELL_ALL = 'SELL_ALL',
    SHORT_SALE_EXEMPT = 'SHORT_SALE_EXEMPT',
    REDEEM = 'REDEEM',
    EXCHANGE = 'EXCHANGE',
    REDEEM_ALL = 'REDEEM_ALL',
    EXCHANGE_ALL = 'EXCHANGE_ALL',
    BUY_MONEY_MARKET_SWEEP = 'BUY_MONEY_MARKET_SWEEP',
    BUY_TO_OPEN = 'BUY_TO_OPEN',
    SELL_TO_OPEN = 'SELL_TO_OPEN',
    CLOSE_CALLS_OR_PUTS = 'CLOSE_CALLS_OR_PUTS',
    SELL_COVERED_CALLS = 'SELL_COVERED_CALLS',
    BUY_CALL_TO_OPEN = 'BUY_CALL_TO_OPEN',
    BUY_PUT_TO_OPEN = 'BUY_PUT_TO_OPEN',
    WRITE_A_COVERED_CALL = 'WRITE_A_COVERED_CALL',
    CLOSE_EXISTING_CALL = 'CLOSE_EXISTING_CALL',
    CLOSE_EXISTING_PUT = 'CLOSE_EXISTING_PUT',
    BUY_CALL_TO_CLOSE = 'BUY_CALL_TO_CLOSE',
    BUY_PUT_TO_CLOSE = 'BUY_PUT_TO_CLOSE',
    SELL_CALL_TO_OPEN = 'SELL_CALL_TO_OPEN',
    SELL_PUT_TO_OPEN = 'SELL_PUT_TO_OPEN',
    BUY_CALLS_PUTS = 'BUY_CALLS_PUTS',
    SELL_AND_BUY = 'SELL_AND_BUY',
    SELL_ALL_AND_BUY = 'SELL_ALL_AND_BUY',
    BUY_TO_CLOSE = 'BUY_TO_CLOSE',
    SELL_TO_CLOSE = 'SELL_TO_CLOSE'
}

export const enum TypeAheadSecurityType {
    OPTION = 'OPTION',
    EQUITY = 'EQUITY',
    UIT = 'UIT',
    CORPDEBT = 'CORPDEBT',
    MUTFUND = 'MUTFUND',
    MONEYMKT = 'MONEYMKT',
    GOVTSEC = 'GOVTSEC',
    LIMPART = 'LIMPART',
    MUNIDEBT = 'MUNIDEBT',
    ASSTBACK = 'ASSTBACK',
    UNIT = 'UNIT'
}

export const enum UserType {
    RIA = 'RIA',
    BD = 'BD',
    DUAL = 'DUAL'
}

export const enum AccountCode {
    ADVI_ACCOUNT_CD = 'ADVI',
    BROKER_ACCOUNT_CD = 'PROF'
}

export interface AllocationOrderWrapper {
    status: string;
    symbol: string;
    transaction: string;
    avgActType: string;
    orderQty: string;
    instruction: string;
    commAmt: string;
    commType: string;
    lmtPrice: string;
    stopLmtPrice: string;
    duration: string;
    dateTime: string;
    approvedBy: string;
    allocAccount: string;
    allocCategory: string;
    handInst: string;
    secType: string;
    tid: string;
    orderFrom: string;
    cnfmOrdFrm: string;
    openCloseCd: string;
}

export interface FulFillment {
    customerId?: string;
    siteId?: string;
    networkId?: string;
    transactionCode: string;
    acctId: string;
    fulfillmentRqstTyp: string;
    srcLeadCode?: string;
    applPromoCode?: string;
    title?: string;
    lastNme: string;
    firstNme: string;
    addrTxt1: string;
    addrTxt2?: string;
    addrTxt3?: string;
    cityNme: string;
    stateCd: string;
    zipCd: string;
    dayPhnNum: string;
    evePhnNum: string;
    faxNum?: string;
    symId: string;
    cusipId: string;
    mfNme: string;
    itemsCnt?: any;
}

export interface Cusip {
    cusipId: string;
    ntwkLevelCode?: string;
    securityName: string;
    symbol: string;
}

export interface ActionPerformed {
    action: string;
    status: string;
}

export const enum ButtonFocus {
    closeBtn = 'closeBtnRef',
    ackOrderBtn = 'ackOrderBtnRef',
    editOrderBtn = 'editOrderBtnRef',
}
